import React from 'react'
import PropTypes from 'prop-types'
import { Chip, Text, useMediaQuery } from '@offerzen/pinata-shame'
import { useParams } from 'react-router-dom'

import SubNavComponent from '@/CandidateExperience/components/SubNav'

import styles from './styles'

const SubNav = () => {
  const { isPhoneOrLarger } = useMediaQuery()
  const { candidateSlug } = useParams()

  return (
    <>
      <If condition={isPhoneOrLarger}>
        <Text className={styles.jobsTitleWrapper}>
          <span className={styles.title}>Jobs</span>
          <Chip label="Beta" size="default" theme="success" className={styles.betaChip} />
        </Text>
      </If>
      <SubNavComponent
        navItems={[
          { href: `/candidate/${candidateSlug}/jobs`, label: 'Available jobs' },
          { href: `/candidate/${candidateSlug}/applications`, label: 'Applications' },
        ]}
      />
    </>
  )
}

SubNav.propTypes = {
  candidateSlug: PropTypes.string,
}

export default SubNav
